module.exports = __webpack_public_path__ + "img/courier-aduiepyle.fa0c3e38.svg";